import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Header      from "../Components/Header/Header";
import IntroPage   from "../Components/IntroPage/IntroPage";
import GalleryPage from "../Components/GalleryPage/GalleryPage";
import ClientsPage from "../Components/ClientsPage/ClientsPage";
import ProfilePage from "../Components/ProfilePage/ProfilePage";

// Client-facing login + route guard
import ClientLogin from "../Components/Client/ClientLogin";
import ProtectedClientRoute from "../Components/Client/ProtectedClientRoute";

// Admin login, dashboard, detail page + route guard
import AdminLogin from "../Components/Admin/AdminLogin";
import AdminDashboard from "../Components/Admin/AdminDashboard";
import UserDetailPage from "../Components/Admin/UserDetailPage";
import ProtectedAdminRoute from "../Components/Admin/ProtectedAdminRoute";

// // 404
// import NotFound from "../pages/NotFound";

function AppRoutes() {
  return (
    <>
      <Routes>
        {/* Default redirect */}
        <Route path="/" element={<Navigate to="/gallery" replace />} />

        {/* Client login (public) */}
        <Route path="/login" element={<ClientLogin />} />

        {/* Client-facing pages - gated behind login */}
        <Route
          path="/Profile"
          element={
            <ProtectedClientRoute>
              <ProfilePage />
            </ProtectedClientRoute>
          }
        />
        <Route
          path="/gallery"
          element={
            <ProtectedClientRoute>
              <GalleryPage />
            </ProtectedClientRoute>
          }
        />
        <Route
          path="/clients"
          element={
            <ProtectedClientRoute>
              <ClientsPage />
            </ProtectedClientRoute>
          }
        />
        <Route
          path="/intro"
          element={
            <ProtectedClientRoute>
              <IntroPage />
            </ProtectedClientRoute>
          }
        />

        {/* Admin login (public) */}
        <Route path="/admin/login" element={<AdminLogin />} />

        {/* Admin dashboard - gated behind admin login */}
        <Route
          path="/admin/dashboard"
          element={
            <ProtectedAdminRoute>
              <AdminDashboard />
            </ProtectedAdminRoute>
          }
        />

        {/* Admin per-client detail view - gated behind admin login */}
        <Route
          path="/admin/users/:userId"
          element={
            <ProtectedAdminRoute>
              <UserDetailPage />
            </ProtectedAdminRoute>
          }
        />

        {/* <Route path="*" element={<NotFound />} /> */}
      </Routes>
    </>
  );
}

export default AppRoutes;